import { Component, Input } from '@angular/core';
import { BenefitsDescriptions } from '@models/types/components/Benefits.type';

@Component({
  selector: 'app-benefits-descriptions',
  standalone: true,
  imports: [],
  templateUrl: './benefits-descriptions.component.html',
  styleUrl: './benefits-descriptions.component.css'
})
export class BenefitsDescriptionsComponent {

  @Input({required: true})
  public descriptions!: BenefitsDescriptions;

}
